module.exports = __webpack_public_path__ + "img/header.4c1a40d6.jpg";